import React from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Formik } from "formik"

import FormikBootstrap from "@/components/formik-bootstrap"
import { submitInternalTourTag } from "@/onboarding/features/product/Slice"
import { getReferenceOptions, getInternalTag } from "@/onboarding/features/product/selectors"
import LoadingSpinner from "@/components/LoadingSpinner"
import { useProductSubmitting } from "@/onboarding/features/product/helpers"

const SetInternalTourTagModal = ({
  show,
  onHide,
}: {
  show: boolean
  onHide: () => void
}): JSX.Element => {
  const dispatch = useDispatch()
  const options = useSelector(getReferenceOptions)
  const internalTag = useSelector(getInternalTag)
  const initialValues = { internalTag: { id: internalTag?.id, label: internalTag?.name } }
  const [isSubmitting, setSubmitting] = useProductSubmitting()

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="set-internal-tour-tag-modal-title"
      centered
    >
      <Modal.Header>
        <Modal.Title id="set-internal-tour-tag-modal-title">
          Update Internal Tour Status
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-4">
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            setSubmitting(true)
            dispatch(submitInternalTourTag({ internalTagId: values?.internalTag?.id }))
          }}
        >
          {({ handleSubmit }) => (
            <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
              <FormikBootstrap.SingleSelect
                name="internalTag"
                label="Internal Tour Status"
                options={options.internalTag}
              />
              <div className="d-flex gap-3">
                <Button type="submit" disabled={isSubmitting}>
                  Submit
                </Button>
                <Button variant="danger" onClick={onHide} disabled={isSubmitting}>
                  Cancel
                </Button>
                {isSubmitting && <LoadingSpinner />}
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default SetInternalTourTagModal
